import Vue from "vue";
import Router from "vue-router";

// Main
import Main_Header from "./pages/main/Header.vue";
import Main_Footer from "./pages/main/Footer.vue";
import Main_Home from "./pages/main/Home.vue";

// Default
import Page404 from "./pages/default/Page404.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: configRoutes()
});

function configRoutes() {
  return [
    {
      path: "/",
      // name: 'home',
      redirect: "/home",
      components: {
        default: Main_Home,
        header: Main_Header,
        footer: Main_Footer
      },
      props: {
        header: {
          colorOnScroll: 400
        },
        footer: {
          backgroundColor: "black"
        }
      }
    },
    {
      path: "/home",
      name: "Home",
      components: {
        default: Main_Home,
        header: Main_Header,
        footer: Main_Footer
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: "black"
        }
      }
    },
    {
      path: "/location",
      name: "Location",
      components: {
        default: Main_Home,
        header: Main_Header,
        footer: Main_Footer
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: "black"
        }
      }
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/404",
      name: "Page404",
      components: {
        default: Page404,
        header: Main_Header,
        footer: Main_Footer
      },
      props: {
        header: {
          colorOnScroll: 0
        },
        footer: {
          backgroundColor: "black"
        }
      }
    },
    {
      path: "/romantic-hakka",
      name: "RomanticHakka",
      beforeEnter() {
        location.href = "https://romantichakka.com/";
      }
    }
  ];
}
